import type { FareEstimate } from '../fares/FareCalculator'
import type { Language, MobilityProviderId, ProviderPosition, ProviderVariant } from '../types'

export interface ProviderAnalyticsContext {
  sessionId: string
  language: Language
  destinationId: string
  providerVariant: ProviderVariant
  estimatedFareBand: string
  krideEnabled: boolean
  uberEnabled: boolean
  locationAvailable: boolean
}

export interface ProviderClickAnalyticsContext extends ProviderAnalyticsContext {
  provider: MobilityProviderId
  providerPosition: ProviderPosition
}

export function estimatedFareBand(fare: FareEstimate | null): string {
  if (!fare) return 'NOT_AVAILABLE'
  const midpoint = Math.round((fare.minWon + fare.maxWon) / 2)
  if (midpoint < 10_000) return 'UNDER_10000_KRW'
  if (midpoint < 20_000) return '10000_19999_KRW'
  if (midpoint < 30_000) return '20000_29999_KRW'
  return '30000_PLUS_KRW'
}

export function providerClickContext(
  context: ProviderAnalyticsContext,
  provider: MobilityProviderId,
  providerPosition: ProviderPosition,
): ProviderClickAnalyticsContext {
  return { ...context, provider, providerPosition }
}
